import { useEffect } from "react";
import Nouislider from "react-nouislider";

function Slider(props) {
  let { range, selectedRange, onUpdate ,specId} = props;
  useEffect(() => {
    document
      .querySelectorAll("#id-price-slider .noUi-handle")
      .forEach((e) => e.classList.add("brc-info-d2", "border-2", "radius-1"));
    document
      .querySelectorAll("#id-price-slider .noUi-base")
      .forEach((e) => e.classList.add("bgc-grey-l1"));

    document
      .querySelectorAll("#id-price-slider .noUi-connect")
      .forEach((e) => e.classList.add("bgc-info-d2"));
    document
      .querySelectorAll("#id-price-slider .noUi-tooltip")
      .forEach((e) =>
        e.classList.add(
          "bgc-dark-tp1",
          "text-white",
          "border-0",
          "text-90",
          "radius-1",
          "px-2"
        )
      );
  });

  const shouldRenderSlider = range[0] !== range[1];
  const step = specId !== 255 ?(range[1] - range[0]) / 4 : 1 ;


  return (
    <div className="pt-35">
      <div
        id="id-price-slider"
        className={`noUi noUi-toggle-tooltip mb-3 slider-thin ${
          shouldRenderSlider ? "" : "hidden"
        }`}
      >
        {shouldRenderSlider && (
          <Nouislider
            tooltips
            start={selectedRange || range}
            connect
            range={{
              min: range[0],
              max: range[1],
            }}
            {...(specId !== 255 ? {
            pips:{
              mode: "positions",
              stepped: true,
              values : [range[0], range[0] + step, range[0] + step * 2, range[1]],
              density: 20,
            }} :{})}
            step={step}
            
            format={{
              from: function (value) {
                return parseInt(value);
              },
              to: function (value) {
                return parseInt(value);
              },
            }}
            onUpdate={(values) => onUpdate && onUpdate([...values])}
          />
        )}
      </div>
    </div>
  );
}

export default Slider;